module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-3-18c928594b4683bf7bc23c90ad8240c5.jpg";